import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#EBC14C" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/profile.php?id=100046503615555"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Jumak Ottawa Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/jumak.ottawa/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Jumak Ottawa Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EBC14C" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/profile.php?id=100046503615555"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Jumak Ottawa Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/jumak.ottawa/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Jumak Ottawa Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
